import clsx from 'clsx';
import React, { useState } from 'react';

export type InputTabOptionType = {
  value: string;
  label: string | React.ReactNode;
};

type InputTabType = {
  defaultValue?: string;
  options: InputTabOptionType[];
  grid?: number;
  disabled?: boolean;
  onChange: (value?: string) => void;
};

export default function InputTab({
  defaultValue,
  options,
  grid = 3,
  disabled,
  onChange,
}: InputTabType) {
  const [tabValue, setTabValue] = useState(defaultValue);

  return (
    <div
      className={clsx(
        'grid w-full items-center gap-y-1 rounded-[6px] bg-[#F8FBFF]',
        `grid-cols-${grid}`
      )}
    >
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => {
            setTabValue(option.value);
            onChange(option.value);
          }}
          className={clsx(
            'flex items-center justify-center rounded-[6px] py-2 text-xs duration-100',
            option.value === tabValue && 'bg-primary text-white',
            disabled && 'opacity-60'
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
